import { jsx as _jsx } from "react/jsx-runtime";
import { AiInterview } from './ai-interview-widget';
import LoginScreen from './components/login-screen';
import { FormProvider } from './context/FormContext';
export const AiInterviewLoginWidget = ({ config, theme, isPreview, }) => {
    return (_jsx(AiInterview, { config: config, theme: theme, isPreview: true, children: _jsx(FormProvider, { children: _jsx(LoginScreen, {}) }) }));
};
